import { render } from "./BaseEmptyState.vue?vue&type=template&id=341da86f&scoped=true"
import script from "./BaseEmptyState.vue?vue&type=script&lang=js"
export * from "./BaseEmptyState.vue?vue&type=script&lang=js"

import "./BaseEmptyState.vue?vue&type=style&index=0&id=341da86f&scoped=true&lang=css"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-341da86f"],['__file',"src/components/helpers/BaseEmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "341da86f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('341da86f', __exports__)) {
    console.log('reload')
    api.reload('341da86f', __exports__)
  }
  
  module.hot.accept("./BaseEmptyState.vue?vue&type=template&id=341da86f&scoped=true", () => {
    console.log('re-render')
    api.rerender('341da86f', render)
  })

}


export default __exports__